define(function(require) {
  var stringUtils = require('common/util/string-utils');
  var urlUtils = require('common/util/bc.url.utils');

  // TODO handle this differently ?
  function unescapeText(text) {
    return $('<div/>').html(text)
      .text();
  }

  function flatOrderItems(items) {
    return _.chain(items)
      .map(function(item) {
        var freeGifts = _.clone(item.freeGifts);
        var freeGiftList = _.map(freeGifts, function(freeGift) {
          freeGift.isFreeGift = true;
          freeGift.quantity = 0;

          return freeGift;
        });

        return [_.omit(item, 'freeGifts'), freeGiftList];
      })
      .flatten()
      .value();
  }

  function getCommerceItemsTotal(items) {
    return items.reduce(function(count, commerceItem) {
      return count + commerceItem.quantity;
    }, 0);
  }

  function buildBackorderPopUpData() {
    const { code: siteCode } = BC.site;
    let popUpData = {};

    if (siteCode !== 'steepcheap') {
      const backorderMessagePrefix = siteCode === 'bcs' ? siteCode : 'cc';

      popUpData = {
        className: 'btn-reset js-remote-modal',
        remotecontenturl: `/Store/content/contentDescription.jsp?id=${backorderMessagePrefix}-stockBackorder`,
        href: `#${backorderMessagePrefix}-stockBackorder`,
      };
    }

    return popUpData;
  }

  function isBackorderable(item) {
    return !item.isFreeGift &&
      item.isOnBackorder &&
      has('backorder') &&
      (item.selloutCode === 'ALLOW_BACKORDER' ||
          (item.isBackorderFromItemsOnPO && item.backorderInventory > 0)
      );
  }

  function isPreorderable(item, preOrderList) {
    return _.contains(preOrderList, item.productId) && item.isBackorderFromItemsOnPO && item.backorderInventory > 0;
  }

  function parseCart(cart) {
    cart.commerceItems = flatOrderItems(cart.commerceItems);
    cart.commerceItems = _.map(cart.commerceItems, parseCartItem.bind(null, cart.preOrderList));
    _.each(cart.formExceptions, function(exception) {
      exception.message = unescapeText(exception.message);
    });
    cart.promotions = _.filter(cart.promotions, function(promo) {
      return promo.promotionType !== 'itemLevelPromo';
    });
    cart.hasBackorderItems = _.some(cart.commerceItems, function(item) {
      return item.isBackorderable;
    });
    cart.count = getCommerceItemsTotal(cart.commerceItems);
    cart.orderSubTotal = parseFloat(stringUtils.removeCurrencyFormat(cart.orderSubTotal));
    cart.orderTotal = parseFloat(stringUtils.removeCurrencyFormat(cart.orderTotal));
    cart.promotionSavings = parseFloat(stringUtils.removeCurrencyFormat(cart.promotionSavings));
    cart.storeCredits = parseFloat(stringUtils.removeCurrencyFormat(cart.storeCredits));
    cart.itemSavings = parseFloat(stringUtils.removeCurrencyFormat(cart.itemSavings));
    if (cart.shipping !== 'FREE!') {
      cart.shipping = parseFloat(stringUtils.removeCurrencyFormat(cart.shipping));
    }

    return cart;
  }

  function parseCartItem(preOrderList, item) {
    if (item.isFreeGift) {
      // TODO defaults might not be needed
      item.productName = item.productName || item.brandDisplayName + ' ' + item.productDisplayName;
      item.skuName = item.skuName || item.displayName + ' - ' + item.skuId;
      item.listPrice = item.listPrice || 0;
      item.salePrice = item.salePrice || 0;
      item.totalPrice = item.totalPrice || 0;
      item.productUrl = item.productUrl || item.url;
    }

    if (item.isDollarDonation) {
      item.productUrl = '#dollar-donation';
      item.popUpData = {
        className: 'btn-reset js-remote-modal',
        remotecontenturl: '/Store/content/contentDescription.jsp?id=bcs-tnc-data',
      };
    }
    item.productName = unescapeText(item.productName);

    if (item.buildConfigJson) {
      BC.buildConfigJson = BC.buildConfigJson || {};
      BC.buildConfigJson[item.id] = JSON.parse(item.buildConfigJson);
    }

    if (has('isNativeApp')) {
      item.productUrl = BC.site.nativeAppSchema + 'pdp/' + item.productId + '/cart';
    }

    if (item.buildId) {
      item.productUrl = urlUtils.addParam(item.productUrl, 'loadSavedBuild', item.buildId);
    }

    item.subItemDetails = {};
    if (item.subItemDetailsJson) {
      item.subItemDetails = JSON.parse(item.subItemDetailsJson);
    }

    item.salePrice = item.detailedUnitPrice || item.listPrice;
    item.isBackorderFromItemsOnPO = item.selloutCode === 'ALLOW_BACKORDER_FOR_ITEMS_ON_PO';
    item.showInventoryWarnings = shouldShowInventoryWarning(item);
    item.isBackorderable = isBackorderable(item);
    item.isPreorderable = isPreorderable(item, preOrderList);
    // Transform every price or number into that, service return them as strings
    item.listPrice = parseFloat(stringUtils.removeCurrencyFormat(item.listPrice));
    item.salePrice = parseFloat(stringUtils.removeCurrencyFormat(item.salePrice));
    item.totalPrice = parseFloat(stringUtils.removeCurrencyFormat(item.totalPrice));

    if (item.backorderInventory) {
      item.backorderInventory = parseFloat(stringUtils.removeCurrencyFormat(item.backorderInventory));
    }

    if (item.detailedUnitPrice) {
      item.detailedUnitPrice = parseFloat(stringUtils.removeCurrencyFormat(item.detailedUnitPrice));
    }

    if (item.isBackorderable) {
      item.backorderPopUpData = buildBackorderPopUpData();
    }

    if (item.itemType === 'warrantyCommerceItem') {
      item.warrantySku.productName = unescapeText(item.warrantySku.productName);
    }

    return item;
  }

  function parseWishlist(wishlist) {
    wishlist.items = wishlist.items || [];
    wishlist.count = wishlist.items.length;
    wishlist.url = wishlist.url || '/' + wishlist.id;

    wishlist.items = _.map(wishlist.items, parseWishlistItem);

    return wishlist;
  }

  function parseWishlistItem(item) {
    item.subItemDetails = {};
    item.groupedItemData = {};

    if (item.subItemDetailsJson) {
      item.subItemDetails = JSON.parse(item.subItemDetailsJson);
    }

    if (item.groupedItemJson) {
      item.productUrl = urlUtils.addParam(item.productUrl, 'loadSavedBuild', item.groupedItemBuildId);
      item.groupedItemData = JSON.parse(item.groupedItemJson);
    }

    item.isGroupedItem = !_.isEmpty(item.subItemDetails);
    item.inventory = parseInt(item.inventory);
    // TODO discard any precision issue when doing this parse
    item.listPrice = parseFloat(stringUtils.removeCurrencyFormat(item.listPrice));
    item.salePrice = parseFloat(stringUtils.removeCurrencyFormat(item.salePrice));

    item.showInventoryWarnings = shouldShowInventoryWarning(item);
    item.isBackorderable = item.backorderable && item.stockStatus === 'backorder';

    if (item.isBackorderable) {
      item.backorderPopUpData = buildBackorderPopUpData();
    }

    return item;
  }

  function updateCartCountCookie(itemCount) {
    BC.setProfileCookie('cartCount', itemCount);
  }

  function shouldShowInventoryWarning(item, minInventory, maxInventory) {
    minInventory = minInventory || 1;
    maxInventory = maxInventory || 5;

    return !item.groupedItem && item.inventory >= minInventory && item.inventory <= maxInventory;
  }

  return {
    buildBackorderPopUpData,
    isBackorderable,
    parseCart,
    parseCartItem,
    parseWishlist,
    parseWishlistItem,
    updateCartCountCookie,
    shouldShowInventoryWarning,
  };
});
